// src/api/userApi.ts
import request from '@/utils/request';

/**
 * 用户API模块
 */
export const userApi = {
    /**
     * 新增用户
     */
    addUser: (formData: FormData) => {
        return request.upload('/api/user/add', formData)
    },
    /**
     * 获取用户列表
     */
    getUserPageList: (requestData: any) => {
        return request.post('/api/user/info/page', requestData)
    },
    /**
     * 获取用户列表
     */
    getUserDetailById: (requestData: any) => {
        return request.get('/api/user/detail/id', requestData)
    },
    /**
     * 修改用户信息
     */
    updateUser(requestData: any) {
        return request.post('/api/user/update', requestData)
    },
    /**
     * 批量删除用户
     */
    handleBatchDeleteUser(requestData: any) {
        return request.post('/api/user/del/batch', requestData)
    },
    /**
     * 修改用户密码
     */
    updateUserPassword(requestData: any) {
        return request.post('/api/user/update/pwd', requestData)
    },
};
